import React__default from 'react';
import { getDropdownComponentBySkin } from './components/option-skins/index.mjs';
import { QuantityDropdown } from '../quantity-list-options/components/option-skins/wide/quantity-dropdown.mjs';
import '../../../../../../../lodash.clonedeep/index.mjs';
import '../../product-option/context/product-option-context.mjs';
import '../../product-option/context/validators/description-validator.mjs';
import '../../product-options-translations/product-option-translations.mjs';
import { useProductOptionContext } from '../../product-option/context/use-product-option-context.mjs';

const DropdownOptions = (props) => {
    const { onChanged, skin, option } = props;
    const { uiDensityQuantityUpdate } = useProductOptionContext();
    const onChangeHandler = (event) => {
        if (onChanged) {
            onChanged({ choiceKey: event.choiceKey });
        }
    };
    const dropdownProps = {
        ...props,
        onChanged: onChangeHandler,
    };
    if (uiDensityQuantityUpdate && option.key === "Quantity") {
        return React__default.createElement(QuantityDropdown, { ...dropdownProps });
    }
    const DropdownComponent = getDropdownComponentBySkin(skin ?? "standard");
    return React__default.createElement(DropdownComponent, { ...dropdownProps });
};

export { DropdownOptions };
//# sourceMappingURL=dropdown-options.mjs.map
